import Loading from "@components/loading/index.jsx";
import React, { useEffect } from "react";

export default function Support() {
	const openChat = () => {
		if (window?.zE && window?.zE?.activate) {
			window?.zE?.activate();
		} else {
			setTimeout(() => {
				openChat();
			}, 200);
		}
	};

	useEffect(() => {
		openChat();
	}, []);

	return <Loading loading={true} />;
}
